var render = function render(){var _vm=this,_c=_vm._self._c;return _c('common-page',{attrs:{"app-title":'定制图:' + _vm.diagramCode}},[_c('CustomizedDiagram',{attrs:{"id":"diagram","diagram-code":_vm.diagramCode}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }